import React from 'react';
import { useToast } from '../hooks/useToast';
import toast from 'react-hot-toast';

const ToastDemo: React.FC = () => {
  const toastHook = useToast();

  const handleSuccessToast = () => {
    console.log('Showing success toast...');
    toastHook.success('Success! Your action was completed successfully.');
  };

  const handleErrorToast = () => {
    console.log('Showing error toast...');
    toastHook.error('Error! Something went wrong. Please try again.');
  };

  const handleWarningToast = () => {
    console.log('Showing warning toast...');
    toastHook.warning('Warning! Please check your input before proceeding.');
  };

  const handleInfoToast = () => {
    console.log('Showing info toast...');
    toastHook.info('Info! Here is some important information for you.');
  };

  const handleDefaultToast = () => {
    console.log('Showing default toast...');
    toastHook.default('Default message! This is a general notification.');
  };

  const handleToastWithDescription = () => {
    console.log('Showing toast with description...');
    toastHook.success('Profile Updated! Your profile information successfully updated.', {
      duration: 5000,
    });
  };

  // Loading toast demo
  const handleLoadingToast = () => {
    console.log('Showing loading toast...');
    const loadingToast = toastHook.loading('Loading... Please wait while we process your request.');
    
    // Simulate API call
    setTimeout(() => {
      toast.dismiss(loadingToast);
      toastHook.success('Request completed successfully!');
    }, 3000);
  };

  // Test direct toast with close button
  const handleDirectToast = () => {
    console.log('Showing direct toast...');
    toast('Direct Toast Test - Should have close button', {
      duration: 5000,
      style: {
        background: '#ffffff',
        color: '#059669',
        border: '2px solid #059669',
        borderRadius: '8px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        fontSize: '14px',
        padding: '12px 16px',
      },
    });
  };

  return (
    <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
      <h2>Toast Demo (React Hot Toast)</h2>
      <p>Click the buttons below to see different types of toast notifications:</p>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        <button 
          onClick={handleSuccessToast}
          style={{ 
            padding: '10px 20px', 
            backgroundColor: '#10b981', 
            color: 'white', 
            border: 'none', 
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          Show Success Toast
        </button>
        
        <button 
          onClick={handleErrorToast}
          style={{ 
            padding: '10px 20px', 
            backgroundColor: '#ef4444', 
            color: 'white', 
            border: 'none', 
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          Show Error Toast
        </button>
        
        <button 
          onClick={handleWarningToast}
          style={{ 
            padding: '10px 20px', 
            backgroundColor: '#f59e0b', 
            color: 'white', 
            border: 'none', 
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          Show Warning Toast
        </button>
        
        <button 
          onClick={handleInfoToast}
          style={{ 
            padding: '10px 20px', 
            backgroundColor: '#3b82f6', 
            color: 'white', 
            border: 'none', 
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          Show Info Toast
        </button>
        
        <button 
          onClick={handleLoadingToast}
          style={{ 
            padding: '10px 20px', 
            backgroundColor: '#6366f1', 
            color: 'white', 
            border: 'none', 
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          Show Loading Toast (3s)
        </button>
        
        <button 
          onClick={handleDefaultToast}
          style={{ 
            padding: '10px 20px', 
            backgroundColor: '#6b7280', 
            color: 'white', 
            border: 'none', 
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          Show Default Toast
        </button>
        
        <button 
          onClick={handleToastWithDescription}
          style={{ 
            padding: '10px 20px', 
            backgroundColor: '#8b5cf6', 
            color: 'white', 
            border: 'none', 
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          Show Toast with Description
        </button>

        <button 
          onClick={handleDirectToast}
          style={{ 
            padding: '10px 20px', 
            backgroundColor: '#059669', 
            color: 'white', 
            border: 'none', 
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          Direct Toast Test (Check for Close Button)
        </button>
      </div>
    </div>
  );
};

export default ToastDemo;
